import { render, staticRenderFns } from "./ReviewTypeModal.vue?vue&type=template&id=fda89640&"
import script from "./ReviewTypeModal.vue?vue&type=script&lang=ts&"
export * from "./ReviewTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewTypeModal.vue?vue&type=style&index=0&id=fda89640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports